// extracted by mini-css-extract-plugin
export default {"mobileBreakPoint":"780px","about":"aboutMe_about__8gbrG","active":"aboutMe_active__4XmlF","ctnSocials":"aboutMe_ctnSocials__A9hh6"};